<div class="w-full rounded-lg bg-gray-200" [class.h-[700px]]="view.size == 'lg'" [class.h-[400px]]="view.size == 'sm'">
  @if (defaultLat && defaultLng && view.locations) {
    <google-map height="100%" width="100%" [options]="{center: {lat: defaultLat, lng: defaultLng}, zoom: view.map.zoom, maxZoom: view.map.maxZoom, styles: view.map.style, disableDefaultUI: view.map.disableUI}">
      <map-marker 
          *ngFor="let location of view.locations" 
          [position]="{ lat: location?.lat, lng: location?.lng }" 
          [title]="location?.title"
          [icon]="{
          url: 'assets/images/xl-travel/XL-logo-transparent.png?v=2',
          scaledSize: { width: 40, height: 40 },
          origin: { x: 0, y: 0 },
          anchor: { x: 20, y: 40 } 
        }">
      </map-marker>
    </google-map>
  }
</div>


<!-- <div class="w-full  bg-gray-200" [class.h-[700px]]="view.size == 'lg'" [class.h-[400px]]="view.size == 'sm'">
    <button class="px-4 py-2 text-white rounded-lg focus:outline-none hover:bg-blue-600">
    🔍 Search
  </button>
  
  Dropdown Search Input
  <div class=" left-0 mt-2 w-full bg-red border border-gray-200  shadow-lg p-2  group-hover:block">
    <input
      type="text"
      placeholder="Type location..."
      (input)="filterNearbyLocations($event)"
      class="w-full px-3 py-2 border border-gray-100 rounded-lg focus:outline-none focus:border-blue-500"
    />
  </div>
    <google-map height="100%" width="100%"
      [options]="{
        center: userLocation || { lat: view.defaultLat, lng: view.defaultLng },
        zoom: view.map.zoom,
        maxZoom: view.map.maxZoom,
        styles: view.map.style,
        disableDefaultUI: view.map.disableUI
      }">
      <map-marker *ngFor="let location of view.nearbyLocations" 
                  [position]="{ lat: location.lat, lng: location.lng }" 
                  [title]="location.title">
      </map-marker>
    </google-map> 
</div>-->
